"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.displayIf = exports.hasClimb = exports.hasNoDistance = exports.hasDistance = exports.isNotDailyStep = exports.isDailyStep = void 0;

var isDailyStep = function isDailyStep(_ref) {
  var isDaily = _ref.activity.isDaily;
  return isDaily;
};

exports.isDailyStep = isDailyStep;

var isNotDailyStep = function isNotDailyStep(activity) {
  return !isDailyStep(activity);
};

exports.isNotDailyStep = isNotDailyStep;

var hasDistance = function hasDistance(_ref2) {
  var distance = _ref2.activity.distance;
  return distance > 0;
};

exports.hasDistance = hasDistance;

var hasNoDistance = function hasNoDistance(activity) {
  return !hasDistance(activity);
};

exports.hasNoDistance = hasNoDistance;

var hasClimb = function hasClimb(_ref3) {
  var climb = _ref3.activity.climb;
  return climb > 0;
};

exports.hasClimb = hasClimb;

var displayIf = function displayIf(condition) {
  return function (displayer) {
    return function (activity) {
      return condition(activity) ? displayer(activity) : undefined;
    };
  };
};

exports.displayIf = displayIf;
//# sourceMappingURL=conditions.js.map